import {useState} from 'react';

export function Domain() {
    //return 'http://localhost/creativeevents/';
    return 'https://creativeteamevents.ch/';
}

export default function Submit({form}) {

    const [message, setMessage] = useState("");

    const isEverythingFilled = () => {
        if (
            typeof form.attendants !== 'undefined'
            && typeof form.date !== 'undefined'
            && typeof form.time !== 'undefined'
            && typeof form.occasionId !== 'undefined'
            && typeof form.activity !== 'undefined'
            && typeof form.deal !== 'undefined'
            && typeof form.dealPrice !== 'undefined'
        ) {
            // if own location and fields are not filled
            if (form.location === 'ownLocation'
                && (
                    typeof form.city === 'undefined'
                    || typeof form.company === 'undefined'
                    || typeof form.street === 'undefined'
                    || typeof form.housenumber === 'undefined'
                    || typeof form.zip === 'undefined'
                )
            ) {
                return false;
            }

            // if pie studio and studio is not selected
            if (form.location === 'pieStudio'
                && typeof form.pieLocation === 'undefined'
            ) {
                return false;
            }

            return true;
        }

        return false;
    }

    const submit = () => {

        let formData = new FormData();

        for (const [key, value] of Object.entries(form)) {
            formData.append(key, value)
        }

        fetch(Domain() + '?api=eventsformrequestcreate', {
            method: 'POST',
            body: formData
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    setMessage("Your request had arrived to Us! We'll contact You soon!");
                } else {
                    setMessage("Something wrong happened! Please refresh the page and try again! :(");
                }
            });
    }

    if (message.length) {
        return (
            <>
                <div className={'submit_container'}>
                    {message}
                </div>
            </>
        );
    }

    if (isEverythingFilled()) {
        return (
            <>
                <div className={'submit_container'}>
                    <button onClick={() => submit()}>Submit Your request</button>
                </div>
            </>
        );
    }

    return (
        <>
            <div className={'submit_container'}>
                Before submit, please fill all the fields! :)
            </div>
        </>
    );
}

